import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DynamicFormField } from '../dynamic-forms/model';
import { Attributes } from '../../../models/attributes';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute } from '@angular/router';
import { AttributesService } from '../../../services/attributes.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { LibraryObjectsSerive } from '../../../services/library_objects.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-dialog-edit-attributes',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatDialogTitle, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './dialog-edit-attributes.component.html',
  styleUrl: './dialog-edit-attributes.component.scss'
})
export class DialogEditAttributesComponent {

  $FORM_CONFIG!: Observable<DynamicFormField[]>
  // attributes$: Observable<Attributes[]>
  state: string = 'creando';
  selectedAttribute: string = ''
  selectedLabel: string = ''
  initialData: any;
  attributesForm: FormGroup;
  attributeId!: number;
  library_attribute_type_id!: any
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogEditAttributesComponent>,
    private route: ActivatedRoute,
    private attributeService: AttributesService,
    private libraryObjectsService: LibraryObjectsSerive,
    private snackBar: MatSnackBar
  ) {
    this.state = this.data.mode === 'edit' ? 'editando' : 'creando';
    console.log('data', data);

    this.selectedAttribute = this.data.attributeType;
    this.selectedLabel = this.data.attributeLabel
    this.initialData = this.data.values || {};
    console.log('Data dialog', this.initialData)


    this.attributesForm = this.fb.group({
      name: [this.initialData.name || '', Validators.required],
      label: [this.initialData.label || '', Validators.required],
      library_attribute_type_id: [this.data.type, Validators.required]
    });


  }
  edit: any
  ngOnInit() {
    this.attributeId = this.initialData['library_attribute_id'];

    console.log(' this.attributesForm.value', this.attributesForm.value);

  }

  save() {
    if (this.attributesForm.valid) {
      const payload = this.attributesForm.value;
      console.log('paaaaa', payload);

      if (this.state === 'editando') {
        this.libraryObjectsService.updateAttribute(this.attributeId, payload).subscribe({
          next: (res) => {
            this.dialogRef.close('refresh');
          },
          error: (err) => console.error('Error:', err)
        });
      } else {
        this.libraryObjectsService.createAttribute(payload).subscribe({
          next: (res: any) => {
            this.dialogRef.close('refresh');
          },
          error: (err) => {
            this.snackBar.open(`${err.error.message}`, 'Cerrar', { duration: 3000 });
          }
        });
      }

    }
  }


}
